import React, { useEffect, useState, useRef } from 'react';
import { Table } from 'antd';
import _ from 'lodash';
import styled from '@emotion/styled';
import { colorConstants } from 'config/colorConstants';
import tw from 'twin.macro';
import { salesGraphWidth } from 'components/organism/GrowthAnalysis/SalesChartContainer/SalesChartContainer';
import { height } from 'components/template/GrowthAnalysis/ExpandedView';
import { classToRemoveScrollbar } from '../MicroIntractions/CopyTOClipBoard';
//import { arePropsEqual } from '../../../utils/helperMethods';

interface props {
    data: any;
    columns: any;
    onRowSelection?: any;
    tableLoading?: any;
    // onPageChange?: any;
    onChange?: any;
    rowKey?: string;
    bordered?: boolean;
    style?: any;
    customHeight?: number;
}

export const CustomTable = styled(Table)`
    .ant-table-sticky-scroll {
        position: static;
    }
    .ant-table-thead > tr > th {
        background: ${colorConstants.grey};
        padding: 0px;
        height: 68px;
    }
    .ant-table-header col:not(:last-child),
    .ant-table-body col {
        min-width: ${salesGraphWidth}px;
    }
    .ant-table-thead
        > tr
        > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not(
            [colspan]
        ):before {
        background: none;
    }
    .ant-table-column-sorter {
        position: relative;
        left: -10px;
    }
    .ant-table-column-sorter-down.active,
    .ant-table-column-sorter-up.active {
        ${tw`text-purpleFont`};
    }
    border: ${'1px solid #DBDFE9'};
`;

//COMPONENT FOR GROWTH ANALYSIS TABLE
const GrowthAnalysisTable: React.FunctionComponent<props> = ({
    data = [],
    bordered = false,
    columns,
    onRowSelection,
    tableLoading,
    rowKey = 'key',
    // onPageChange,
    onChange,
    style = {},
    customHeight,
}) => {
    // const [currentPage, setCurrentPage] = useState(1);
    // const onPaginationChange = (page:number, size:number) => {
    //     setCurrentPage(page);
    //     onPageChange(page, size);
    // };

    // const { data: tableData, count } = data;
    return (
        <CustomTable
            bordered={bordered}
            pagination={false}
            scroll={{ x: '100%', y: customHeight || height }}
            sticky
            style={style}
            rowKey={(record: any) => record[rowKey]}
            columns={columns}
            dataSource={data}
            rowSelection={onRowSelection}
            loading={tableLoading}
            onChange={(pagination, filters, sorter, extra) => {
                if (onChange) onChange(pagination, filters, sorter, extra);
            }}
            // pagination={{
            //     defaultPageSize: defaultPageSize,
            //     total: data ? data.count : 0,
            //     onChange: (page, pageSize) => onPaginationChange(page, pageSize),
            //     current: currentPage,
            // }}
        />
    );
};

export default React.memo(GrowthAnalysisTable);
